import { ArrowLeftOutlined } from '@ant-design/icons';
import { App, Button, Card, Form, Space, Typography } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import {
  buildProjectPayload,
  ProjectFormFields,
  type ProjectFormValues,
} from '@/pages/admin/projects/ProjectFormFields';
import { ApiError } from '@/services/api/client';
import * as projectsApi from '@/services/api/projects';

export function ProjectCreatePage() {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm<ProjectFormValues>();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values: ProjectFormValues) => {
    setSubmitting(true);
    try {
      const created = await projectsApi.createProject(buildProjectPayload(values));
      message.success('项目创建成功');
      navigate(ROUTES.admin.projectDetail(created.id));
    } catch (error) {
      const text = error instanceof ApiError ? error.message : '创建项目失败';
      message.error(text);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(ROUTES.admin.projects)}>
          返回列表
        </Button>
      </Space>

      <Typography.Title level={4} style={{ marginTop: 0 }}>
        创建项目
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        创建项目档案并指定负责人。项目负责人创建后负责持续提交项目周报。
      </Typography.Paragraph>

      <Card>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            projectCategories: [],
            annualPlanYear: new Date().getFullYear(),
            departmentIds: [],
          }}
          onFinish={handleSubmit}
          style={{ maxWidth: 920 }}
        >
          <ProjectFormFields form={form} />

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={submitting}>
                提交创建
              </Button>
              <Button onClick={() => navigate(ROUTES.admin.projects)}>取消</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
